/**
 * Extend Marb namespace with ads specific content
 *
 * @author AB
 */

try {
	Marb.extend({
		Page : {
			Ads : {
				mlBase : {ar: 'https://api.mercadolibre.com/sites/MLA', br: 'https://api.mercadolibre.com/sites/MLB'},
				/**
				 * Show a horizontal promo bar at the specified location
				 * in params.
				 * Params:
				 * - selector: the container of the horizontal bar
				 * - categoryId: our own category id which is used for searching (mandatory if no job specified)
				 * - jobId: a job Id to be used as base for searching
				 * - trackLabel: the label to use for tracking purposes when clickin on an ad
				 */
				showHorizontalPromoBar : function(params){
					var container = $(params.selector);
					var mlCountryBase = this.mlBase[(params.country || 'ar').toLowerCase()];
					var url = '';
					var urlParams = params.urlParams || {};
					if( params.categoryId ){
						url = '/ads/meli/category/' + params.categoryId;
					}else if( params.jobId ){
						url = '/ads/meli/job/' + params.jobId;
					}else{
						debug.error('must include one of "jobId" or "categoryId" as param');
						return;
					}
					var meliContainer = 
						$('<div class="ml-results-container-h"> \
									<div> \
								<img src="/static/images/loading.gif" style="vertical-align: top"> Cargando promociones... \
							</div> \
						</div>');
					container.append(meliContainer);
					var itemTemplate = 
						$('<div class="ml-item-result template"> \
								<a href="#" target="_blank"> \
								<img class="ml-item-img" src="" /> \
								<div class="ml-item-name"></div> \
								<div class="ml-item-price"></div> \
								</a> \
								<div class="ml-arrow-box"> \
									<img class="ml-item-detail-img" src="" /> \
									<div class="ml-item-detail-name"></div> \
									<div class="ml-item-detail-price"></div> \
								</div> \
							</div>');
					
					//get filter params from server
					var meliSearchUrl = mlCountryBase + '/search';
					$.get(url, urlParams, function(response){
						if( ! response.success ){
							debug.error('response unsuccessful');
							return;
						}
						
						//set tracking values
						var trackEvent, trackLabel;
						trackLabel = params.trackLabel || "generic";
						if( params.categoryId ){
							trackEvent= 'cat_' + params.categoryId + "-" + response.data.category;
						}else{
							trackEvent= 'job-' + response.data.category; 
						}
						//create merged filter
						var searchData = {
							condition: 'new',
							buying_mode: 'buy_it_now',
							has_pictures: 'yes',
							//category: 'MLA48895',
							//state: 'AR-C',
							//q: query,
							limit: 50,
							nonce: Math.random()
						};
						$.extend(true, searchData, response.data);
						//query meli
						$.get(meliSearchUrl ,searchData, function(data){
							if(data.paging.total < 3){
								debug.warn('only ' + data.paging.total + ' results');
							}
							var container = meliContainer;
							container.html('');
							var results = data.results;
							var start = results.length - 8;
							if( start < 0 ){
								start = 0;
							}else{
								start = Math.floor(Math.random()*start);
							}
							var maxItems = start + 8;
							//render items
							for(var i=start; i < maxItems; i++){
								var result = results[i];
								var item = itemTemplate.clone();
								item.data('ml-id', result.id);
								item.find('.ml-item-img').attr('src', result.thumbnail);
								item.find('.ml-item-price').text('$' + result.price);
								item.find('a')
									.attr('href', result.permalink)
									.on('click', function(){
										Marb.Commons.Track.event('ads-meli', trackEvent, trackLabel);
										return true;
									});

								
								item.find('.ml-item-detail-name').text(result.title);
								item.find('.ml-item-detail-img').attr('src', result.thumbnail);
								item.find('.ml-item-detail-price').text('$' + result.price);
								
								container.append(item);
							}
						});
					});
				}
			}
		}
	});
}
catch (e) {
	alert(e);
	debug.error("Marb namespace not present", e);
}